import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';

import { pxToRem } from 'theme-loader/theme/typography';

const AlertPopup = (props) => {
  const {
    children,
    onConfirm,
    isOpen,
    handleClose,
    rightBtnSx = {},
    title,
    description,
    cancelButtonText,
    submitButtonText,
    isConfirmLoading,
    isConfirmDisabled,
    onExited = () => {},
    paperStyles,
    cancelBtnDisable = false,
    cancelBtnSx = {},
    hasCancelBtn = true,
    onClose = () => {},
    hasCloseIcon = false,
  } = props;

  // Handle key press (Enter to submit)
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !isConfirmLoading && !isConfirmDisabled) {
      onConfirm();
    }
  };
  return (
    <Dialog
      TransitionProps={{
        onExited: onExited,
      }}
      open={isOpen || false}
      onClose={(event, reason) => {
        if (!isConfirmLoading && reason !== 'backdropClick') {
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ boxShadow: 'none' }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0,0,0,0.5)',
        },
      }}
      PaperProps={{
        style: {
          boxShadow: 'none',
          ...paperStyles,
        },
      }}
      onKeyDown={handleKeyDown}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      {hasCloseIcon && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      )}
      {description ? (
        <DialogContent sx={{ overflowY: 'unset' }}>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
      ) : null}
      {children}
      <DialogActions>
        {hasCancelBtn ? (
          <Button
            disabled={cancelBtnDisable}
            onClick={() => {
              if (!isConfirmLoading) {
                handleClose();
              }
            }}
            sx={{ fontSize: pxToRem(17), mr: 2, ...cancelBtnSx }}
            color="error"
          >
            {cancelButtonText || 'Cancel'}
          </Button>
        ) : null}
        <LoadingButton
          loading={isConfirmLoading}
          disabled={isConfirmLoading || isConfirmDisabled}
          onClick={() => onConfirm()}
          autoFocus
          sx={{ fontSize: pxToRem(17), mr: 1, ...rightBtnSx }}
        >
          {submitButtonText || 'Login'}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

AlertPopup.propTypes = {
  cancelBtnDisable: PropTypes.bool,
  cancelBtnSx: PropTypes.object,
  cancelButtonText: PropTypes.string,
  children: PropTypes.element,
  description: PropTypes.string,
  handleClose: PropTypes.func,
  hasCancelBtn: PropTypes.bool,
  hasCloseIcon: PropTypes.bool,
  isConfirmDisabled: PropTypes.bool,
  isConfirmLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onExited: PropTypes.func,
  paperStyles: PropTypes.any,
  rightBtnSx: PropTypes.object,
  submitButtonText: PropTypes.string,
  title: PropTypes.string,
};

export default AlertPopup;
